/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { ChangeDetectionStrategy, Component, ContentChild, Directive, ViewEncapsulation } from '@angular/core';

@Directive({
  selector: '[empty-state-illustration]',
  standalone: true,
})
export class EmptyStateIllustrationDirective {}

@Directive({
  selector: '[empty-state-description]',
  standalone: true,
})
export class EmptyStateDescriptionDirective {}
@Directive({
  selector: '[empty-state-action]',
  standalone: true,
})
export class EmptyStateActionDirective {}
@Directive({
  selector: '[empty-state-title]',
  standalone: true,
})
export class EmptyStateTitleDirective {}

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  // No encapsulation allows to style ng-content children
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class EmptyStateComponent {
  @ContentChild(EmptyStateIllustrationDirective) illustration? = undefined;
}
